import { Controller } from '@hotwired/stimulus'
import * as liveRegion from '../../helpers/live_region_helper'

export default class extends Controller {
  static targets = ['currentError', 'totalErrors', 'total']

  connect() {
    this.formBody = this.element.parentNode.querySelector('.superform-form-body')
    this.liveRegion = liveRegion.assertive
    this.resetErrors()
    addEventListener('turbo:render', this.resetErrors)
  }

  disconnect() {
    removeEventListener('turbo:render', this.resetErrors)
  }

  resetErrors = () => {
    this.errorCount = this.formBody.querySelectorAll('.invalid-feedback').length
    if (this.errorCount > 0) {
      // yes, this is annoying and hacky. an aria-live region will not make an announcement unless the text content changes, so
      // this is a way to repeat an announcement even when the same number of errors is present.
      // the same hack exists in the live region helpers, but since the content is replaced here by turbo, the content is not preserved
      // in the dom and the same hack must be applied here against the previousErrorAnnouncement variable
      let errorAnnoucement = `${this.errorCount} issues found. Please resolve before continuing`
      if (this.previousErrorAnnouncement && errorAnnoucement === this.previousErrorAnnouncement) {
        errorAnnoucement = errorAnnoucement + '.'
      }
      this.previousErrorAnnouncement = errorAnnoucement
      this.liveRegion.setContent(errorAnnoucement)
    }

    this.currentError = 0
    this.currentErrorTarget.innerText = this.currentError
    this.totalTarget.innerText = this.errorCount
    this.totalErrorsTarget.innerText = `${this.errorCount} ${this.errorCount === 1 ? 'issue' : 'issues'} found.`
  }

  nextError() {
    let nextError = this.currentError + 1

    nextError > this.errorCount ? (this.currentError = 1) : (this.currentError = nextError)

    this.navigate()
  }

  previousError() {
    let previousError = this.currentError - 1

    previousError <= 0 ? (this.currentError = this.errorCount) : (this.currentError = previousError)

    this.navigate()
  }

  navigate() {
    this.currentErrorTarget.innerText = this.currentError

    let invalidFields = this.formBody.querySelectorAll('.invalid-feedback')

    if (invalidFields.length > 0) {
      let fieldWithError = invalidFields[this.currentError - 1]

      if (fieldWithError) {
        const parent = fieldWithError.parentElement
        parent.scrollIntoView();
        const inputWithError = parent.querySelector('input[aria-invalid], input.react-date-time.is-invalid, select[aria-invalid], textarea[aria-invalid]')
        if (inputWithError) inputWithError.focus()
      }
    }
  }
}
